import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../utils/handlers';

function FavoriteButton({ isFavorite, handleFavoriteClick, onWhiteBg, className }) {
  // Don't display if no click handler given
  if (!handleFavoriteClick) {
    return null;
  }

  const classes = ['clickable', styles.favorite];
  if (onWhiteBg) {
    classes.push(styles.onWhiteBg);
  }
  if (isFavorite) {
    classes.push(styles.selected);
  }
  if (className) {
    classes.push(className);
  }
  const title = isFavorite ? StringConstantsMixin.strings.SEARCH.REMOVE_FROM_LIST : StringConstantsMixin.strings.SEARCH.ADD_TO_LIST;
  return (
    <button
      aria-label={title}
      className={classes.join(' ')}
      onClick={wrapEventHandler(handleFavoriteClick)}
      title={title}
      type="button"
      data-testid={title}
    />
  );
}

FavoriteButton.propTypes = {
  handleFavoriteClick: PropTypes.func.isRequired,
  isFavorite: PropTypes.bool,
  onWhiteBg: PropTypes.bool
};

FavoriteButton.defaultProps = {
  isFavorite: false,
  onWhiteBg: false
};

export default FavoriteButton;
